import { jsx as _jsx } from "react/jsx-runtime";
import styles from './Burger.module.css';
export var Burger = function (_a) {
    var onClick = _a.onClick, dataTestId = _a.dataTestId;
    return (_jsx("div", { className: styles.burger, "data-test-id": dataTestId, onClick: onClick }));
};
